// extracted by mini-css-extract-plugin
export default {"spinner":"Common_spinner__HWon4","layoutWithHeader":"Common_layoutWithHeader__5ZekA","layout":"Common_layout__rVmpW","mainContainer":"Common_mainContainer__wwxKw"};